export default "__VITE_ASSET__DmBFGN$I__"